var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-container',{attrs:{"widget":_vm.widget}},[_c('div',{style:(`max-height: 100%; max-width: 100%; height: 100%; ${
      _vm.hasTitle ? 'padding-bottom: 4rem' : ''
    }`)},[(_vm.opts !== undefined && _vm.max !== undefined && _vm.min !== undefined)?_c('e-chart',{style:(`z-index: 1; width: 100%; height: ${
        _vm.hasOneEighty ? '100%;' : '100%;'
      } overflow: hidden`),attrs:{"option":_vm.opts,"autoresize":true}}):(this.max === undefined || this.min === undefined)?_c('div',[_vm._v(" "+_vm._s(_vm.$t("module.gauge.missingMaxMin"))+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.$t("module.noData"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }